import { StatiquePageService } from './../Service/statique-page.service';
import { Component, Input, OnChanges, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import { Global } from '../Service/global.service';

@Component({
  selector: 'app-statique-menu',
  templateUrl: './statique-menu.component.html',
  styleUrls: ['./statique-menu.component.scss']
})
export class StatiqueMenuComponent implements OnInit, OnChanges {
  lgsub: any;
  routesub: any;
  @Input()
  lg;

  @Input()
  cururl;

  constructor(public global: Global,
    private service: StatiquePageService,
    private aroute: ActivatedRoute,
    private router: Router) { }
  menus = [];
  currentUrl = '';
  isArab = false;
  ngOnInit(): void {
    // this.lgsub = this.global.CurentLanguage.pipe(takeUntil(this.global.navigationEnd)).subscribe(lg => {

    // });
  }
  ngOnChanges() {
    this.lg.code == "ar" ? this.isArab = true : this.isArab = false;
    const url = this.cururl;
    this.currentUrl = url;
    let section = ''
    // if (url !== undefined && url !== null) {
    //   if (url.indexOf('/agence/') !== -1) {
    //     section = 'Agence';
    //   } else if (url.indexOf('/grands-chantiers/') !== -1) {
    //     section = 'Grands Chantiers';
    //   } else if (url.indexOf('/missions/') !== -1) {
    //     section = 'Missions';
    //   } else if (url.indexOf('/formation-portuaire/') !== -1) {
    //     section = 'Formation Portuaire';
    //   } else if (url.indexOf('/services/') !== -1) {
    //     section = 'Services';
    //   } else if (url.indexOf('/publications/') !== -1) {
    //     section = 'Publications';
    //   } else if (url.indexOf('/espace-professionnel/') !== -1) {
    //     section = 'Espace Professionnel';
    //   } else if (url.indexOf('/acces-rapide/') !== -1) {
    //     section = 'Acces rapide';
    //   }
    // }
    this.menus = [];
    this.service.getMenu(this.lg.url).subscribe(m => {
      let a = m['value'].filter(ele => {
        return ele['ApplicationUrl']? url.toLowerCase().indexOf(ele['ApplicationUrl'].toLowerCase()) != -1: false
      })
      console.log(a);
      section = a[0]["Section"];
      let datas = m['value'].filter(ele => {
        return ele.Section==section;
      })
      datas.forEach(element => {
        const obj = {
          Title: element.Title,
          url: element.ApplicationUrl,
          ordre: element.Ordre
        }
        this.menus.push(obj);
      });
      this.menus.sort(function (a, b) {
        return a.ordre - b.ordre;
      });
      this.global.sidebar();
    })
    // this.service.getMenuBySection(section, this.lg.url).subscribe(datas => )
  }
  iseirect(ApplicationUrl : string){
    return ApplicationUrl && ApplicationUrl.indexOf('http') != -1
  }
}
